import React from 'react';
import { CognocracyHero } from '../../components/cognocracy/CognocracyHero';
import { CognocracyFoundation } from '../../components/cognocracy/CognocracyFoundation';
import { CognocracyCredential } from '../../components/cognocracy/CognocracyCredential';
import { CognocracyGovernance } from '../../components/cognocracy/CognocracyGovernance';
export function CognocracyPage() {
  return <>
      <CognocracyHero data-id="element-1984" data-mp="3kgo6h2872k2k" />
      <CognocracyFoundation data-id="element-1985" data-mp="3kfd1x06xd8ae" />
      <CognocracyCredential data-id="element-1986" data-mp="3ki7niv1ocz5e" />
      <CognocracyGovernance data-id="element-1987" data-mp="3ohgfbud5mmyb" />
    </>;
}